// Module
var code = "<div class=\"deployment-plan-flow\"> <div class=\"tbl\" name=\"{{value.flowName}}\"> <div class=\"cell tbl-name\" title=\"{{name}}\"> {{name}} </div> <div class=\"cell tbl-dg\"> {{value.dg}} </div> <div class=\"cell tbl-nodes\"> {{value.strategy}} </div> </div> </div> ";
// Exports
export default code;